// extracted by mini-css-extract-plugin
export default {"root":"app_root__jUzsc","mainLayout":"app_mainLayout__9+0CD"};